module.exports = __webpack_public_path__ + "img/PP-active.58ad74d8.svg";